import { FIELD_ERROR_CLASS, useError } from '../../field-error';
import { FIELD_TYPES, InputBorderStyle } from '../../constants';
import { useFieldValidation } from '../../contexts/field-validation-context';
import { useConfig } from '../../contexts/config-context';
import { ForcedState, useForcedState } from '../../contexts/forced-state-context';
import { getInputBorderStyle, useStyleParams } from '../../contexts/style-params-context';
import React, { useCallback } from 'react';
import { TextArea as TPATextArea, TextAreaTheme } from 'wix-ui-tpa/cssVars';
import classNames from 'classnames';
import { classes } from './text-area.st.css';
import FieldLabel from '../field-label';
import FieldDescription from '../field-description';
import FieldError from '../field-error';
import { getInputId, getLabelId, getDescriptionId, getErrorId, getAriaDescribedBy } from '../../services/field-attributes';
// TODO pass required to TPA after contribution
export const TextAreaComponent = _ref => {
  let {
    id,
    target,
    path,
    label,
    hideLabel,
    placeholder,
    required,
    value,
    onChange,
    error,
    customErrors,
    disabled = false,
    description,
    fieldType = FIELD_TYPES.TEXT_AREA,
    FieldLayout
  } = _ref;
  const inputId = getInputId(id);
  const labelId = getLabelId(id);
  const {
    hasError,
    errorMessage
  } = useError(error, customErrors, fieldType);
  const {
    validateFields
  } = useFieldValidation();
  const {
    isMobile
  } = useConfig();
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  const descriptionId = getDescriptionId(id);
  const errorId = getErrorId(id);
  const styleParams = useStyleParams();
  const borderStyle = getInputBorderStyle(styleParams, isMobile);
  const handleChange = useCallback(event => {
    const newValue = event.target.value;
    onChange(newValue);
    if (hasError) {
      validateFields({
        path,
        value: newValue
      });
    }
  }, [onChange, hasError, validateFields, path]);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(FieldLabel, {
      labelId: labelId,
      htmlFor: inputId,
      required: required,
      label: label,
      hideLabel: hideLabel
    }),
    renderInput: () => /*#__PURE__*/React.createElement(TPATextArea, {
      id: inputId,
      error: hasError,
      newErrorMessage: true,
      className: classNames(classes.textArea, {
        [FIELD_ERROR_CLASS]: hasError,
        [classes.noBorder]: borderStyle === InputBorderStyle.None,
        [classes.hover]: forcedHover
      }),
      ariaLabel: label,
      value: value ? String(value) : '',
      onChange: handleChange,
      disabled: disabled,
      placeholder: placeholder,
      onBlur: event => validateFields({
        path,
        value: event.target.value
      }),
      theme: borderStyle === InputBorderStyle.Bottom ? TextAreaTheme.Line : TextAreaTheme.Box,
      "aria-describedby": getAriaDescribedBy(errorId, descriptionId)
    }),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldError, {
      target: target,
      hasError: hasError,
      errorMessage: errorMessage,
      id: errorId
    }), /*#__PURE__*/React.createElement(FieldDescription, {
      description: description,
      id: descriptionId
    }))
  });
};
//# sourceMappingURL=text-area-component.js.map